import JSONPath from 'jsonpath';

/**
 * 
 * @param {string} parserType can have values 'regex', 'json' or 'xml'. Defines which type of parser needs to executed 
 * @param {string} text is the text that needs to be parsed 
 * @param {string} userInput is the part that needs to be matched. Can be either regex pattern, jsonpath or xpath 
 * @returns 
 */
export const toposParser = (parserType, text, userInput) => {
    let matchedText = []
    switch (parserType) {
        case 'regex':
            const regex = new RegExp(userInput, 'g');
            matchedText = text.match(regex) || [];
            return matchedText
        case 'json':
            const parsedJSON = JSON.parse(text);
            matchedText = JSONPath.query(parsedJSON, userInput);

            return matchedText;

        case 'xml':
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(text, 'text/xml');

            const result = xmlDoc.evaluate(
                userInput,
                xmlDoc,
                null,
                XPathResult.ANY_TYPE,
                null
            );

            let node = result.iterateNext();
            while (node) {
                matchedText.push(new XMLSerializer().serializeToString(node) + "\n");
                node = result.iterateNext();
            }

            return matchedText;

        default:
            break;
    }
}